import classNames from 'classnames';
import React from 'react';
import SubmenuButton from 'atoms/SubmenuButton/SubmenuButton';
import Bar from 'layout/atoms/Bar';
import Caption from 'layout/atoms/Caption';
import Loader from 'layout/atoms/Loader/Loader';
import styles from './Submenu.module.scss';
function Submenu({ groups }) {
    const wrapClasses = classNames(styles.wrap, styles.active);
    return (React.createElement("nav", { className: wrapClasses },
        React.createElement("main", { className: styles.main }, groups.map((group) => (React.createElement("div", { key: group.id, className: styles.group },
            group.header && (React.createElement(Bar, { height: 24, hp: 8 },
                React.createElement(Caption, { color: "subtle" }, group.header))),
            group.loading ? (React.createElement(Loader, null)) : (group.items.map((item) => (React.createElement(SubmenuButton, { key: item.id, to: item.to, icon: item.icon, text: item.text, onClick: item.onClick }))))))))));
}
export default Submenu;
